/**
 * Internal dependencies
 */
import cecSdk from 'lib/customer-ec-sdk';
import * as actions from 'state/action-types';
import receiveConnections from './receive-connections';

export default  (connectionId) => (dispatch) => {
    
    dispatch({
        type: actions.CONNECTIONS_REQUEST,
    });

    if (!connectionId) {
        throw 'no id provided';
    }

    return cecSdk
        .connection(connectionId)
        .get()
        .then((connection) => {
            dispatch({
                type: actions.CONNECTIONS_REQUEST_SUCCESS,
            });

            dispatch(receiveConnections([connection]));
            return connection;
        });
};